import React, { FunctionComponent, useState } from 'react';
import type { RecruitmentShowCompanyProps } from './types';
import type { CompanyProfile } from '../../../types/companyDetail';
import { RecruitmentShowPeople } from '../recruitmentShowPeople';

type Props = & RecruitmentShowCompanyProps & {
  profile: CompanyProfile;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  noimage,
  noIconImg,
  isStopped,
  dataCategory,
  dataValue,
  profile,
  isPreview,
  isShowToggleInRecruitmentShowPage = false
}) => {
  const [isInformationOpen, setIsInformationOpen] = useState(false);
  const [isMissionOpen, setIsMissionOpen] = useState(false);
  const isShowInformation = () => profile.informationTitle !== null && profile.informationDescription !== null && profile.informationTitle !== '' && profile.informationDescription !== '';
  const isShowMission = () => profile.missionTitle !== null && profile.missionDescription !== null && profile.missionTitle !== '' && profile.missionDescription !== '';

  return (
    <div className="recruitment__show__content recruitment__show__company last">
      {profile.coverRecruitmentImg &&
        <img src={profile.coverRecruitmentImg} alt='カバー画像' className="coverImg" />
      }

      <RecruitmentShowPeople
        recruitmentId={recruitmentId}
        isStopped={isStopped}
        companyId={companyId}
        noimage={noimage}
        noIconImg={noIconImg}
        dataCategory={dataCategory}
        dataValue={dataValue}
        isPreview={isPreview}
      />

      {isShowInformation() && (
        <div className="recruitment__show__company__section" id="what-doing-section">
          {isShowToggleInRecruitmentShowPage ? (
            <>
              <button
                type="button"
                className="title recruitment__show__toggle gtm-toggle-view-count"
                onClick={() => setIsInformationOpen(!isInformationOpen)}
                aria-expanded={isInformationOpen}
                aria-controls="what-doing-toggle-content"
                data-event-name="toggle on screen"
                data-event="click"
                data-category="recruitmentcontent"
                data-value="toggle_what_doing"
              >
                何をやってるのか/独自のサービス
              </button>
              {isInformationOpen && (
                <div className="information" id="what-doing-toggle-content">
                  {profile.informationTitle && <h3 className="subTitle">{profile.informationTitle}</h3>}
                  <div
                    dangerouslySetInnerHTML={{ __html: profile.informationDescription ?? '' }}
                    className='information--text'
                  />
                  <div className="information--flex">
                    {profile.informationImage1 && (
                      <div className={`information--flex--item ${!profile.informationImage2 && 'is-wide'}`}>
                        <img src={profile.informationImage1.url} alt={`${profile.informationImage1Description}画像`} />
                        <p dangerouslySetInnerHTML={{ __html: profile.informationImage1Description ?? '' }} />
                      </div>
                    )}
                    {profile.informationImage2 && (
                      <div className="information--flex--item">
                        <img src={profile.informationImage2.url} alt={`${profile.informationImage2Description}画像`} />
                        <p dangerouslySetInnerHTML={{ __html: profile.informationImage2Description ?? '' }} />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <h2 className="title">何をやってるのか/独自のサービス</h2>
              <div className="information">
              {profile.informationTitle && <h3 className="subTitle">{profile.informationTitle}</h3>}
              <div
                dangerouslySetInnerHTML={{ __html: profile.informationDescription ?? '' }}
                className='information--text'
              />
              <div className="information--flex">
                {profile.informationImage1 && (
                  <div className={`information--flex--item ${!profile.informationImage2 && 'is-wide'}`}>
                    <img src={profile.informationImage1.url} alt={`${profile.informationImage1Description}画像`} />
                    <p dangerouslySetInnerHTML={{ __html: profile.informationImage1Description ?? '' }} />
                  </div>
                )}
                {profile.informationImage2 && (
                  <div className="information--flex--item">
                    <img src={profile.informationImage2.url} alt={`${profile.informationImage2Description}画像`} />
                    <p dangerouslySetInnerHTML={{ __html: profile.informationImage2Description ?? '' }} />
                  </div>
                )}
              </div>
            </div>
            </>
          )}
        </div>
      )}

      {isShowMission() && (
        <div className="recruitment__show__company__section" id='company-role-section'>
          {isShowToggleInRecruitmentShowPage ? (
            <>
              <button
                type="button"
                className="title recruitment__show__toggle gtm-toggle-view-count"
                onClick={() => setIsMissionOpen(!isMissionOpen)}
                aria-expanded={isMissionOpen}
                aria-controls="company-role-toggle-content"
                data-event-name="toggle on screen"
                data-event="click"
                data-category="recruitmentcontent"
                data-value="toggle_company_role"
              >
                企業の役割（企業理念）
              </button>
              {isMissionOpen && (
                <div className="information" id="company-role-toggle-content">
                  {profile.missionTitle && <h3 className="subTitle">{profile.missionTitle}</h3>}
                  <div
                    dangerouslySetInnerHTML={{ __html: profile.missionDescription ?? '' }}
                    className='information--text'
                  />
                  <div className="information--flex">
                    {profile.missionImage1 && (
                      <div className={`information--flex--item ${!profile.missionImage2 && 'is-wide'}`}>
                        <img src={profile.missionImage1.url} alt={`${profile.missionImage1Description}画像`} />
                        <p dangerouslySetInnerHTML={{ __html: profile.missionImage1Description ?? '' }} />
                      </div>
                    )}
                    {profile.missionImage2 && (
                      <div className="information--flex--item">
                        <img src={profile.missionImage2.url} alt={`${profile.missionImage2Description}画像`} />
                        <p dangerouslySetInnerHTML={{ __html: profile.missionImage2Description ?? '' }} />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <h2 className="title">企業の役割（企業理念）</h2>
              <div className="information">
              {profile.missionTitle && <h3 className="subTitle">{profile.missionTitle}</h3>}
              <div
                dangerouslySetInnerHTML={{ __html: profile.missionDescription ?? '' }}
                className='information--text'
              />
              <div className="information--flex">
                {profile.missionImage1 && (
                  <div className={`information--flex--item ${!profile.missionImage2 && 'is-wide'}`}>
                    <img src={profile.missionImage1.url} alt={`${profile.missionImage1Description}画像`} />
                    <p dangerouslySetInnerHTML={{ __html: profile.missionImage1Description ?? '' }} />
                  </div>
                )}
                {profile.missionImage2 && (
                  <div className="information--flex--item">
                    <img src={profile.missionImage2.url} alt={`${profile.missionImage2Description}画像`} />
                    <p dangerouslySetInnerHTML={{ __html: profile.missionImage2Description ?? '' }} />
                  </div>
                )}
              </div>
            </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
